import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function Impressum() {
  return (
    <div className="min-h-screen bg-[#020617]">
      <Header />
      <main className="max-w-4xl mx-auto px-6 py-16">
        <div className="bg-white rounded-2xl shadow-lg p-8 lg:p-12">
          <h1 className="text-3xl md:text-4xl font-semibold mb-8 text-[#020617]">
            Impressum
          </h1>

          <div className="prose prose-lg max-w-none text-[#020617]">
            <h2 className="text-2xl font-semibold mb-4">Angaben gemäß § 5 DDG</h2>

            <div className="mb-8">
              <p className="mb-2">
                <strong>AbschleppDirekt24</strong>
                <br />
                Inhaber: Dominic Zanotelli
                <br />
                Roonstraße 15
                <br />
                13585 Berlin
                <br />
                Telefon:{' '}
                <a href="tel:+4915214468574" className="text-[#dc2626] hover:underline">
                  +49 1521 4468574
                </a>
                <br />
                E-Mail:{' '}
                <a href="mailto:info@abschleppdirekt24.de" className="text-[#dc2626] hover:underline">
                  info@abschleppdirekt24.de
                </a>
                <br />
                Website:{' '}
                <a href="https://www.abschleppdirekt24.de" className="text-[#dc2626] hover:underline">
                  https://www.abschleppdirekt24.de
                </a>
              </p>
            </div>

            <h2 className="text-2xl font-semibold mb-4 mt-8">Umsatzsteuer-ID</h2>
            <p className="mb-8">
              Umsatzsteuer-Identifikationsnummer gemäß § 27 a Umsatzsteuergesetz:
              <br />
              DE94816230775
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">Streitschlichtung</h2>
            <p className="mb-4">
              Wir sind nicht bereit oder verpflichtet, an Streitbeilegungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>
            <p className="mb-4">Unsere E-Mail-Adresse finden Sie oben im Impressum.</p>
            <p className="mb-8">Ein Hinweis auf die frühere EU-OS-Plattform erfolgt nicht mehr, da diese eingestellt wurde.</p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">Haftung für Inhalte</h2>
            <p className="mb-4">
              Als Diensteanbieter sind wir gemäß § 7 DDG für eigene Inhalte auf diesen Seiten nach den
              allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 DDG sind wir als Diensteanbieter jedoch nicht
              verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
              forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
            </p>
            <p className="mb-4">
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen Gesetzen
              bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der Kenntnis
              einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden
              wir diese Inhalte umgehend entfernen.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">Haftung für Links</h2>
            <p className="mb-4">
              Unser Angebot enthält Links zu externen Websites Dritter, auf deren Inhalte wir keinen Einfluss haben.
              Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
              Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte waren zum
              Zeitpunkt der Verlinkung nicht erkennbar.
            </p>
            <p className="mb-4">
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte einer
              Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
              umgehend entfernen.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">Urheberrecht</h2>
            <p className="mb-4">
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
              Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
              Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
            </p>
            <p className="mb-4">
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
              beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
              Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden
              von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
            </p>

            <h2 className="text-2xl font-semibold mb-4 mt-8">Bildernachweise</h2>
            <p className="mb-4">Bildmaterial erstellt mit Canva Pro (canva.com)</p>

            <p className="mb-4">© Copyright 2025 AbschleppDirekt24 – Alle Rechte vorbehalten.</p>

            <div className="mt-12 pt-8 border-t-2 border-[#020617]">
              <p className="text-sm opacity-70">Stand: Dezember 2025</p>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
